import { queryOptions } from "@tanstack/react-query";
import type {
  NotificationId,
  NotificationListDto,
  NotificationPreferenceDto,
} from "@yalana/contracts";
import { fetchApi } from "@shared/infrastructure/api-client";

type NotificationList = ReturnType<(typeof NotificationListDto)["parse"]>;

export const notificationsQueries = {
  all: () => ["notifications"] as const,

  unread: () =>
    queryOptions<NotificationList>({
      queryKey: ["notifications", "unread"],
      queryFn: () => fetchApi<NotificationList>("/api/notifications"),
      staleTime: 0,
    }),

  preferences: () =>
    queryOptions<{ preferences: NotificationPreferenceDto[] }>({
      queryKey: ["notifications", "preferences"],
      queryFn: () =>
        fetchApi<{ preferences: NotificationPreferenceDto[] }>(
          "/api/notifications/preferences",
        ),
    }),
};

export const notificationsMutations = {
  markRead: (id: NotificationId) => ({
    mutationFn: () =>
      fetchApi<{ success: boolean }>(`/api/notifications/${id}/read`, {
        method: "PATCH",
      }),
  }),

  markAllRead: () => ({
    mutationFn: () =>
      fetchApi<{ success: boolean }>("/api/notifications/read-all", {
        method: "PATCH",
      }),
  }),

  updatePreferences: () => ({
    mutationFn: (preferences: NotificationPreferenceDto[]) =>
      fetchApi<{ success: boolean }>("/api/notifications/preferences", {
        method: "PUT",
        body: JSON.stringify({ preferences }),
        headers: { "Content-Type": "application/json" },
      }),
  }),
};
